import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Award } from 'lucide-react';
export const Guarantee: React.FC = () => {
  return <section className="py-10 md:py-20 bg-primary text-white relative overflow-hidden" data-id="element-170">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-171"></div>

      {/* Subtle glow behind shield */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-64 h-64 bg-accent/20 blur-[80px] rounded-full pointer-events-none" data-id="element-172"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="inline-flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full bg-gradient-to-b from-white/20 to-white/5 mb-6 md:mb-8 border border-white/20 shadow-[0_0_30px_rgba(76,175,80,0.3)] relative" data-id="element-174">
          <motion.div animate={{
          scale: [1, 1.1, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} data-id="element-175">
            <ShieldCheck size={40} className="md:hidden text-accent" data-id="element-176" />
            <ShieldCheck size={56} className="hidden md:block text-accent" data-id="element-177" />
          </motion.div>

          {/* Small decorative stars */}
          <div className="absolute -top-2 -right-2 text-yellow-400 text-xl animate-pulse" data-id="element-178">
            ✨
          </div>
          <div className="absolute -bottom-1 -left-2 text-yellow-400 text-lg animate-pulse delay-75" data-id="element-179">
            ✨
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold font-serif mb-4 md:mb-6 drop-shadow-md" data-id="element-180">
          GARANTÍA PROFES DE TELAS RESUELTO — 7 DÍAS
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-4 md:space-y-6 text-base md:text-xl text-gray-200" data-id="element-181">
          <p className="font-medium text-white text-sm md:text-lg" data-id="element-182">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés.
          </p>

          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-6 py-4 shadow-lg" data-id="element-183">
            <p className="font-bold text-accent text-lg md:text-3xl" data-id="element-184">
              Si en 7 días no es lo que esperabas: <br className="md:hidden" data-id="element-185" />{' '}
              Te devolvemos el 100%.
            </p>
          </div>

          <p className="italic text-sm md:text-base text-gray-300" data-id="element-186">
            Sin preguntas. Sin formularios. Sin drama.
          </p>

          <div className="pt-6 md:pt-10 mt-6 md:mt-10 border-t border-white/10 flex flex-col items-center" data-id="element-187">
            <p className="text-sm md:text-base text-gray-300 max-w-2xl mb-6" data-id="element-188">
              La confianza que tenemos en Profes de Telas Resuelto™ nos permite
              hacer esa promesa sin dudar. Más de 300 profes de telas de todo el
              país ya lo saben.
            </p>

            <div className="inline-flex items-center gap-2 bg-green-500/20 text-green-300 border border-green-500/30 px-4 py-2 rounded-full" data-id="element-189">
              <Award size={18} data-id="element-190" />
              <span className="text-xs md:text-sm font-bold uppercase tracking-widest" data-id="element-191">
                Tasa de devoluciones menor al 1%
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};